import apiClient from '@/utils/apiClient'
import GetSupplierOrderListController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetSupplierOrderListController'
import GetSupplierOrderByIdController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetSupplierOrderByIdController'
import GetSupplierOrderAvailableItemsController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetSupplierOrderAvailableItemsController'
import AddItemStockToSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/AddItemStockToSupplierOrderController'
import AddItemDossierToSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/AddItemDossierToSupplierOrderController'
import AddItemsToSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/AddItemsToSupplierOrderController'
import UpdateFreeItemStockFromSupplierOrderItemController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/UpdateFreeItemStockFromSupplierOrderItemController'
import DeleteSupplierOrderItemController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/DeleteSupplierOrderItemController'
import RemoveItemStockFromSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/RemoveItemStockFromSupplierOrderController'
import RemoveItemDossierFromSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/RemoveItemDossierFromSupplierOrderController'
import GetDraftSupplierOrdersBySupplierController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetDraftSupplierOrdersBySupplierController'
import CreateSupplierOrderWithItemDossierController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/CreateSupplierOrderWithItemDossierController'
import GetCateringSupplierOrderByDossierController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/GetCateringSupplierOrderByDossierController'
import CreateSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/CreateSupplierOrderController'
import UpdateSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/UpdateSupplierOrderController'
import UpdateSupplierOrderStatusController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/UpdateSupplierOrderStatusController'
import ReceiveSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/ReceiveSupplierOrderController'
import CloseSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/CloseSupplierOrderController'
import CancelSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/CancelSupplierOrderController'
import DeleteSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/DeleteSupplierOrderController'
import SendSupplierOrderToSupplierController from '@/wayfinder/actions/App/Http/Controllers/SupplierOrder/SendSupplierOrderToSupplierController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  //region Fetch
  async fetchAllSupplierOrders({ commit }, payload: Record<string, any> = {}) {
    const { filters = [], page = 1, per_page = 50, force_unlimited } = payload
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSupplierOrderListController.post(), {
          filters,
          page,
          per_page,
          force_unlimited
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchSupplierOrderByID: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      return apiClient
        .route(
          GetSupplierOrderByIdController.get({ supplier_order: payload.id }),
          {
            skipNotFoundToast: payload.skipNotFoundToast
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewSupplierOrder({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'supplierOrder' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetSupplierOrderAvailableItemsController.get({
            supplier_order: payload.supplier_order_id
          })
        )
        .then((response) => {
          commit('setSupplierOrder', response.data.supplierOrder)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  addItemStocksToSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemStockToSupplierOrderController.post({
            supplier_order: payload.supplier_order_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossierToSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemDossierToSupplierOrderController.post({
            supplier_order: payload.supplier_order_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemsToSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemsToSupplierOrderController.post({
            supplier_order: payload.supplier_order_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateFreeItemStock({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateFreeItemStockFromSupplierOrderItemController.put({
            supplier_order_item: payload.supplier_order_item_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteSupplierOrderItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteSupplierOrderItemController.delete({
            supplier_order_item: payload.supplier_order_item_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  removeItemStocksFromSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RemoveItemStockFromSupplierOrderController.delete({
            supplier_order: payload.supplier_order_id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  removeItemDossiersFromSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RemoveItemDossierFromSupplierOrderController.delete({
            supplier_order: payload.supplier_order_id
          }),
          {
            data: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportSupplierOrderPDF: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/supplier-order/render/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDraftSupplierOrdersBySupplierId(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDraftSupplierOrdersBySupplierController.get({
            supplier: payload.supplier_id
          }),
          {
            params: {
              dossier_id: payload.dossier_id,
              funeral_home_id: payload.funeral_home_id
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  createSupplierOrderWithItemDossier(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateSupplierOrderWithItemDossierController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchDraftSupplierOrderBySupplierId({ commit }, payload) {
    await apiClient
      .get(`/api/invoicing/draft-supplier-order/${payload.supplier_id}`)
      .then(async (response) => {
        if (response.status === 200) {
          commit('setInvoiceIndex', response.data.invoices)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchDraftSupplierOrderBySupplierId', reason)
      })
  },

  async fetchCateringSupplierOrderByDossierId({ commit }, payload) {
    await apiClient
      .route(
        GetCateringSupplierOrderByDossierController.get({
          dossier: payload.dossier_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setInvoiceIndex', response.data.invoices)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchCateringSupplierOrderByDossierId', reason)
      })
  },

  //endregion

  //region store
  storeSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateSupplierOrderController.post(), payload.supplier_order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  //region update
  updateSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateSupplierOrderController.put({
            supplier_order: payload.supplier_order_id
          }),
          payload.supplier_order
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateSupplierOrderStatus(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateSupplierOrderStatusController.patch({
            supplier_order: payload.supplier_order_id
          }),
          {
            status: payload.status
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async receiveSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ReceiveSupplierOrderController.put({
            supplier_order: payload.supplier_order_id
          }),
          payload.supplier_order
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  closeSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CloseSupplierOrderController.put({
            supplier_order: payload.supplier_order_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  cancelSupplierOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CancelSupplierOrderController.put({
            supplier_order: payload.supplier_order_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  // region delete
  deleteSupplierOrderById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteSupplierOrderController.delete.delete({
            supplier_order: payload.id
          }),
          {
            params: {
              delete_item_dossiers: payload.delete_item_dossiers ?? false
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteSupplierOrderById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteSupplierOrderController.undo.get({ id: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  sendSupplierOrderToSupplier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendSupplierOrderToSupplierController.post({
            supplier_order: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
